import { httpClient } from 'app/api/http/http-client';
import { useMutation } from 'react-query';
import { OtpRequestType, OtpResponseType } from 'app/utils/services/types/otp.type';

const otpService = {
  sendOtp: async (data: { data: OtpRequestType; url: string }): Promise<OtpResponseType> => {
    try {
      const result = await httpClient.post<OtpResponseType>(data.url, data.data);

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }
    }
  },
  getOtp: async (data: any) => {
    try {
      const result = await httpClient.post(`/api-web/v1/main/confirm_email?business_key=${data}`);

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }
    }
  },
};

export const useOtpService = () => {
  const {
    isSuccess: isSuccessOtp,
    isLoading: isLoadingOtp,
    data: dataOtp,
    mutate: otpMutation,
  } = useMutation(['otp'], (data: { data: OtpRequestType; url: string }) => otpService.sendOtp(data));

  return { isSuccessOtp, isLoadingOtp, dataOtp, otpMutation };
};

export const useGetOtpService = () => {
  const {
    isLoading: isLoadingGetOtp,
    data: dataGetOtp,
    mutate: getOtpMutation,
  } = useMutation(['getOtp'], (data: any) => otpService.getOtp(data));

  return { isLoadingGetOtp, dataGetOtp, getOtpMutation };
};
